import {
  Box,
  Button,
  FooterActionBar,
  Illustration,
  ModalIsland,
  Typography,
} from "@saviynt/design-system";
import { FormattedMessage, useIntl } from "react-intl";

type CreateUserSuccessModalProps = {
  isOpen: boolean;
  email: string;
  onDone: () => void;
};

export default function CreateUserSuccessModal({
  isOpen,
  email,
  onDone,
}: CreateUserSuccessModalProps) {
  const intl = useIntl();

  return (
    <ModalIsland
      isOpen={isOpen}
      onClose={onDone}
      title={intl.formatMessage({
        id: "Flcow+",
        defaultMessage: "User created successfully",
        description: "Success modal title after creating a user",
      })}
      contentBody={
        <Box className="flex w-full flex-col items-center gap-6 py-4">
          <Illustration
            kind="Confirmation"
            dataTestId="CreateUserSuccessModal-illustration"
          />
          <Typography
            kind="body1"
            color="--color-foreground-primary-bold"
            desktop="body1-d"
            className="text-center"
          >
            <FormattedMessage
              id="bR3C7i"
              defaultMessage="Login credentials have been sent to their email: {email}"
              description="Login credentials have been sent to their email"
              values={{ email }}
            />
          </Typography>
        </Box>
      }
      FooterActionBarComp={
        <FooterActionBar size="large">
          <Box className="flex w-full justify-end">
            <Button
              kind="filled"
              size="medium"
              onClick={onDone}
              dataTestId="CreateUserSuccessModal-doneButton"
            >
              <FormattedMessage
                id="fq4IPE"
                defaultMessage="Done"
                description="Done"
              />
            </Button>
          </Box>
        </FooterActionBar>
      }
    />
  );
}
